import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../config/config.service';
import {CountriesService} from '../countries/countries.service';
import {AirportsService} from '../airports/airports.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class FiltersService {

    public filterFlags: any = [
        {
            'serverName': 'filters_category_everything', 'order': 0,
            'title': 'Everything', 'imageName': 'filters_category_everything', 'key': 'everything_flag'
        },
        {'serverName': 'adventure', 'order': 1, 'title': 'Adventure', 'imageName': 'filters_category_adventure', 'key': 'adventure_flag'},
        {
            'serverName': 'culture', 'order': 2, 'title': 'Culture Vulture',
            'imageName': 'filters_category_culture_vulture', 'key': 'culture_flag'
        },
        {'serverName': 'nightlife', 'order': 3, 'title': 'Night Owl', 'imageName': 'filters_category_night_owl', 'key': 'nightlife_flag'},
        {'serverName': 'food', 'order': 4, 'title': 'Foodie', 'imageName': 'filters_category_foodie', 'key': 'food_flag'},
        {'serverName': 'beach', 'order': 5, 'title': 'Beach', 'imageName': 'filters_category_beach', 'key': 'beach_flag'},
        {'serverName': 'romantic', 'order': 6, 'title': 'L O V E', 'imageName': 'filters_category_love', 'key': 'romantic_flag'},
        {'serverName': 'chill', 'order': 7, 'title': 'Chill', 'imageName': 'filters_category_chill', 'key': 'chill_flag'},
        {
            'serverName': 'winter_sports', 'order': 8, 'title': 'Winter Sports',
            'imageName': 'filters_category_winter_sports', 'key': 'winter_sports_flag'
        },
        {'serverName': 'sports', 'order': 9, 'title': 'Sports', 'imageName': 'filters_category_sports', 'key': 'sports_flag'},
        {'serverName': 'hot', 'order': 10, 'title': 'Hot', 'imageName': 'filters_category_adventure', 'key': 'hot_flag'},
        {'serverName': 'off_grid', 'order': 11, 'title': 'Off Grid', 'imageName': 'filters_category_off_grid', 'key': 'off_grid_flag'},
        {'serverName': 'winter', 'order': 12, 'title': 'Winter', 'imageName': 'filters_category_winter', 'key': 'winter_flag'},
        {'serverName': 'hottest', 'order': 13, 'title': 'Hot', 'imageName': 'filters_category_hot', 'key': 'hottest_flag'},
        {'serverName': 'city', 'order': 14, 'title': 'City Slickers', 'imageName': 'filters_category_city', 'key': 'city_flag'},
        {
            'serverName': 'covid_19_safe', 'order': 15, 'title': 'Covid Safe',
            'imageName': 'filters_category_covid_safe', 'key': 'covid_19_safe_flag'
        }];
    public selectedFlags;

    private budgetUpdates = new BehaviorSubject<any>(undefined);
    public budgetUpdatesObservable = this.budgetUpdates.asObservable();
    private budgetMinValueFlash = new BehaviorSubject<any>(undefined);
    public budgetMinValueFlashObservable = this.budgetMinValueFlash.asObservable();

    private filtersActivity = new BehaviorSubject<any>(undefined);
    public filtersActivityObject = this.filtersActivity.asObservable();

    constructor(
        private configService: ConfigService,
        private countriesService: CountriesService,
        private airportsService: AirportsService,
        private http: HttpClient,
        private translate: TranslateService) {
    }

    getFlagFilters() {
        const _allowedFlags = this.configService.getAvailableFlagFilters();
        const _drawableFlags: Array<any> = [];
        this.filterFlags.forEach(flagObj => {
            const _flagName = flagObj.serverName;
            if (_allowedFlags.indexOf(_flagName) > -1 || _flagName === 'filters_category_everything') {
                _drawableFlags.push(flagObj);
            }
        });
        return _drawableFlags.sort((a, b) => a.order - b.order);
    }

    getSelectedFlags() {
        return this.configService.getSelectedFlags();
    }

    updateSelectedFlags(selectedFlags) {
        this.configService.storeSelectedFlags(selectedFlags);
    }

    getAccommodationTags() {
        return this.configService.hotelTags;
    }

    getSelectedAccommodationTags() {
        return this.configService.getSelectedAccommodationTags();
    }

    updateAccommodationTags(tags) {
        this.configService.storeSelectedAccommodationTags(tags);
    }

    getUserLocation(success: Function, fail: Function) {
        this.configService.useBrowserGeoLocation(success, fail);
    }


    getAvailableAirPorts() {
        return this.airportsService.getAllAirports();
    }

    getAvailableFlattenedAirports() {
        return this.airportsService.flattenAirports;
    }

    getSelectedAirports() {
        return this.configService.getSelectedAirports();
    }

    getAirportCategory() {
        return this.configService.getAirportCategory();
    }

    storeAirportCategory(cat) {
        this.configService.storeAirportCategory(cat);
    }


    storeSelectedAirports(airports: Array<any>) {
        this.configService.storeSelectedAirports(airports);
    }

    getAvailableCountries() {
        return this.countriesService.countries;
    }

    getSelectedAccommodationTypes() {
        return this.configService.getSelectedAccommodationType();
    }

    storeSelectedAccommodation(accommodationId) {
        this.configService.storeHotelId(accommodationId);
    }

    storeSelectedAccommodationTypes(selectedAccoArray) {
        this.configService.storeSelectedAccommodationType(selectedAccoArray);
    }

    getPeopleCount() {
        return this.configService.getPeopleCounter();
    }

    storePeopleCount(pplCount) {
        this.configService.storePeopleCounter(pplCount);
    }

    updateUserCountry(countryCode) {
        this.configService.setUserCountry(countryCode);
    }

    getDateObject() {
        return this.configService.getSelectedDates();
    }

    storeDateObject(dateObj) {
        this.configService.storeSelectedDates(dateObj);
    }

    getUserCountry() {
        return this.configService.getUserDefaultCountry();
    }

    filtersChanged(res) {
        this.filtersActivity.next(res);
    }

    getLuckyDatesMonthsCount() {
        return this.configService.configurations.app_config_lucky_dates_months_number;
    }

    getLuckyDatesMaxMonthsSelected() {
        return this.configService.configurations.app_config_max_lucky_dates_months_number;
    }

    getCovidStatus() {
        return this.configService.getCovid();
    }

    storeCovidStatus(val: boolean) {
        this.configService.storeCovid(val);
    }

    getMaxAdultsCount() {
        return this.configService.configurations.app_config_maximum_number_of_people;
    }

    getMinAdultsCount() {
        return this.configService.configurations.app_config_number_of_people;
    }

    getInfantsMaxAge() {
        return this.configService.configurations.app_config_max_infant_age_in_months;
    }

    getChildrenMaxAge() {
        return this.configService.configurations.app_config_max_child_age_in_years;
    }

    getMaxChildrenPerAdult() {
        return this.configService.configurations.app_config_max_number_of_children_per_adult;
    }

    getChildrenMaxCount() {
        return this.configService.configurations.app_maximum_number_of_children;
    }

    getChildren() {
        return this.configService.getChildrenArray();
    }

    storeChildren(children: Array<any>) {
        this.configService.storeChildrenArray(children);
    }

    isInfant(date): boolean {
        return this.configService.isInfant(date);
    }

    isChild(date): boolean {
        return this.configService.isChild(date);
    }

    childrenCount() {
        return this.configService.getChildrenCount();
    }

    infantsCount() {
        return this.configService.getInfantsCount();
    }

    getAccommodationFiltersConfig() {
        return this.configService.configurations.app_config_accommodation_filters_switch;
    }

    getWhereToList(): Observable<any> {
        const whereToURL = environment.apiUrl.baseUrl + environment.apiUrl.services.whereTo;
        const payload = this.getWhereToRequestPayload();
        return this.http
            .get(whereToURL, payload)
            .pipe(map(
                (response: any) => {
                    return response;
                },
                (error: any) => {
                    return error;
                }
            ));
    }

    getWhereToRequestPayload() {
        const _selectedAirports = this.getSelectedAirports();
        const _countryObj = this.getUserCountry();
        const _flags = this.getSelectedFlags();
        const options: any = {};
        options.params = new HttpParams({});
        _selectedAirports.forEach((element, index) => {
            options.params = options.params.append('airport_iata_codes[' + index + ']', element);
        });
        // const flagsSwitch = this.getWhereToFlagsSwitch();
        // if (flagsSwitch === 'yes') {
        _flags.forEach(element => {
            options.params = options.params.append(element, '1');
        });
        // }
        options.params = options.params.append('country_code', _countryObj.country_code);
        options.params = options.params.append('language_code', this.translate.currentLang);
        options.params = options.params.append('platform', 'WEB');
        options.params = options.params.append('image_size', '1080');
        options.params = options.params.append('cache-control', new Date().getTime() as any);
        return options;
    }

    getWhereToFlagsSwitch() {
        return this.configService.configurations.app_config_where_to_search_flags_switch;
    }

    getWhereToValue() {
        return this.configService.getSelectedWhereToValues();
    }

    setWhereToObject(value) {
        this.configService.storeWhereToObject(value);
    }

    getWhereToCountriesMinimumSelection() {
        return this.configService.configurations.app_config_where_to_minimum_countries_selection;
    }

    getWhereToDestinationsMinimumSelection() {
        return this.configService.configurations.app_config_where_to_minimum_groups_selection;
    }

    getWhereToPreViewValue() {
        const whereToObject = this.getWhereToValue();
        return whereToObject.value;
    }

    getMaximumNumberOfNights() {
        return this.configService.configurations.app_config_maximum_number_of_nights;
    }

    getMinDayToLeave() {
        const minDays = this.configService.configurations.app_config_calendar_min_days_to_leave || 0;
        return minDays ? minDays : null;
    }

    getUserBudget() {
        return this.configService.getUserBudget();
    }

    updateBudgetView(res) {
        this.budgetUpdates.next(res);
    }

    budgetMinValueFlashUpdates(res) {
        this.budgetMinValueFlash.next(res);
    }
}
